@if (total) {
<div>
    <div class="search-result-header" [class.search-result-header-revamp]="isGridFilterRevampEnabled$ | async">
        @if (originalSearch !== suggestedTemplate) { @if (isGridFilterRevampEnabled$ | async) {

        <p i18n="@@hermes.grid-page.search.no-result-found"> No results found for « {{ originalSearch }} » </p>

        } @else {

        <p
            i18n="@@hermes-global-translations.no-results.multi-suggestion"
            class="sub-title"
            role="alert"
            aria-live="polite"
            i18n-aria-live>
            Oops! No results found for &ldquo;{{ originalSearch }}&rdquo;, here are the results for
            {{ suggestedTemplate }}
            instead.
        </p>

        } }
        <h1 class="main-title" tabindex="-1" [style.text-align]="(isGridFilterRevampEnabled$ | async) ? 'left' : ''">
            @if (isGridFilterRevampEnabled$ | async) {

            <span [innerHTML]="searchResultForInnerHtml"></span>

            } @else {

            <span i18n="@@hermes-global-translations.search-results-for">
                Abracadabra! Here are the results for “{{ query }}”
            </span>

            }

            <span class="total" [attr.aria-hidden]="'true'"> ({{ total }}) </span>

            <span hSrOnlyNoSnippet>
                <span>, {{ total }} </span>
                @if (total > 1) {
                <span>
                    <span i18n="@@hermes.accessibility.items"> items </span>
                </span>
                } @else {

                <span i18n="@@hermes.accessibility.item"> item </span>

                }
            </span>
        </h1>
    </div>

    <!-- For screen reader only. Informs the user that the products list has been updated -->
    <p
        class="sr-only"
        [attr.aria-live]="'polite'"
        [attr.aria-atomic]="'true'"
        [attr.aria-hidden]="hideTotalUpdatedItems">
        <span i18n="@@hermes.accessibility.update">Update</span>
        <span>, {{ total }} </span>
        @if (total < 2) {
        <span>
            <span i18n="@@hermes.accessibility.item">item</span>
        </span>
        } @else {

        <span i18n="@@hermes.accessibility.items">items</span>

        }
    </p>
</div>
} @else { @if (isGridFilterRevampEnabled$ | async) { @if (displayedItemNumber) {

<span class="search-result-header search-result-header-revamp">
    <p i18n="@@hermes.grid-page.search.no-result-found"> No results found for « {{ originalSearch }} » </p>
    <span
        i18n="@@hermes.grid-page.search.recommendation"
        class="main-title"
        [style.text-align]="(isGridFilterRevampEnabled$ | async) ? 'left' : ''">
        You might be interested in one of these items:
    </span>
</span>

} @else {

<ng-container i18n="@@hermes-global-translations.product_grid_msg_no_results_notification_description">
    Sorry, we currently do not have any item that match your search.
</ng-container>

} } @else {

<h-grid-no-result>
    @if (displayedItemNumber) {
    <ng-container i18n="@@hermes-global-translations.no-results-found.search">
        No results found for &ldquo;{{ originalSearch }}&rdquo;, but you might be interested in one of these items:
    </ng-container>
    } @else {

    <ng-container i18n="@@hermes-global-translations.product_grid_msg_no_results_notification_description">
        Sorry, we currently do not have any item that match your search.
    </ng-container>

    }
</h-grid-no-result>

} }
